import { callApi } from '../../../../apiCaller';
import { toastError } from '../../../../utils';

import { API_SUBSCRIBER_ORGANIZATION, API_SUBSCRIBER_ORGANIZATION_USER, ORG_USER_ROLES } from '../../../../constants';
import { switchOrg } from '../../../../helpers/subscriber';

import { setCurrentCountry } from '../GlobalStates/CurrentCountry/actions';
import { setSubscriberUser } from '../GlobalStates/CurrentUser/actions';

import { setManagedOrganizations } from '../../Organizations/ManagedOrganizations/actions';
import { setOrganizationOrders } from '../../Organizations/Purchases/Orders/action';
import { setOrganization } from '../../Organizations/Purchases/PaymentMethod/action';

const fetchManagedOrganization = (organizationId, navigate) => async (dispatch) => {
     return await callApi(API_SUBSCRIBER_ORGANIZATION_USER, 'GET').then((response) => {
          if (response.status !== 200) {
               toastError(response);
               return;
          }

          dispatch(setManagedOrganizations(response.data));
          switchOrg({ managedOrganizations: response.data, organizationId, dispatch, navigate }); // Switch to the org which has just been created
     });
};

export const addSubscriberOrganization = (newOrganization, setSubmitting, setShowPopup, navigate) => async (dispatch, getState) => {
     const user = getState().subscriber.user;

     return await callApi(API_SUBSCRIBER_ORGANIZATION, 'POST', newOrganization).then(async (response) => {
          setSubmitting(false);

          if (response.status !== 200) {
               toastError(response);
               return;
          }

          const newOrg = response.data;
          await dispatch(fetchManagedOrganization(newOrg.id, navigate));
          const _newOrg = {
               ...newOrg,
               OrganizationUsers: { role: ORG_USER_ROLES.OWNER },
          };

          if (user) {
               user.organizations.push(_newOrg);
               dispatch(setSubscriberUser(user));
          }

          dispatch(setCurrentCountry(_newOrg.country));
          dispatch(setOrganizationOrders(null));
          dispatch(setOrganization(null));
          setShowPopup(false);

          return newOrg;
     });
};
